(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/hooks/use-payment-history.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/hooks/use-payment-history.js');
'use strict';

const usePaymentHistory = () => {
  const getHightchartOptions = club => {
    const seriesOptions = club.yearlystatistics.map(year => ({
      data: year.monthlystatistics.map(month => {
        var _month$payment;
        return month.payment ? (_month$payment = month.payment) === null || _month$payment === void 0 ? void 0 : _month$payment.sectionamount : 0;
      }),
      name: year.year
    }));
    return {
      chart: {
        type: 'spline'
      },
      title: {
        text: club.longname
      },
      subtitle: {
        text: club.subcategory
      },
      series: seriesOptions,
      xAxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      yAxis: {
        title: {
          text: 'Kronor'
        }
      }
    };
  };
  return {
    getHightchartOptions
  };
};
svs.grassroots_partner.usePaymentHistory = usePaymentHistory;

 })(window);